import React, { useEffect, useState } from "react";
import TitleDocPlace from "../../../components/title/title";
import LoadingComponent from "../../../components/loading";
import SearchDocPlace from "../../../components/search/search";
import { useDispatch, useSelector } from "react-redux";
import DataGridDemo from "./resource/grid/grid";
import { getRequiredProcess } from "../../../store/workFlow/actions";

export const RequestedWorkflow = () => {
  const dispatch = useDispatch();
  /* eslint-disable no-unused-vars -- setDocumentName reserved for future use */
  const [documentName, setDocumentName] = useState([]);
  /* eslint-enable no-unused-vars */
  const [, setUserRequiredSignature] = useState(true);
  const [rows, setRows] = useState([]);

  const {
    responseGetRequiredProcess,
    loadingGetRequiredProcess,
  } = useSelector((state) => ({
    responseGetRequiredProcess:
      state.WorkFlowProcess.responseGetRequiredProcess?.data,
    loadingGetRequiredProcess: state.WorkFlowProcess.loadingGetRequiredProcess,
  }));

  useEffect(() => {
    dispatch(getRequiredProcess());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getRequiredProcess());
  }, [dispatch]);

  useEffect(() => {
    let newObject = [];
    if (responseGetRequiredProcess?.length > 0) {
      responseGetRequiredProcess?.forEach((row, i) => {
        newObject.push({ ...row, id: i });
      });
      setRows(newObject);
    }
  }, [responseGetRequiredProcess]);

  const findDocumentTypes = (term) => {
    setUserRequiredSignature(
      term
        ? documentName.filter((doc) =>
            doc.document_name.toLowerCase().includes(term)
          )
        : documentName
    );
  };

  const searchFile = (filterSearch) => {
    findDocumentTypes(filterSearch);
  };

  return (
    <>
      <TitleDocPlace
        title={"Documents for approval process"}
        viewActive={false}
      />
      <LoadingComponent
        show={loadingGetRequiredProcess}
        text={"Obtaining documents for approval process..."}
      />
      <div style={{ float: "right" }}>
        <SearchDocPlace callSearch={searchFile.bind(this)} />
      </div>

      <DataGridDemo rows={rows} />
    </>
  );
};
